module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_map_black-13c4ce9b49d5559e7f294121b295ffa9.svg";